import styled from 'styled-components';

const SectionHeader = styled.h2`
  text-align: ${({ align }) => align || 'center'};
  text-transform: uppercase;
  color: ${({ theme }) => theme.sectionTitleColour || '#000'};
  font-family: ${({ theme }) => theme.headerFont};
  font-size: ${(props) => (props.as === 'h3' ? '18px' : '24px')};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  margin: ${(props) => (props.as === 'h3' || props.noGutter ? '10px 0' : '0 0 59px 0')};
`;

export default SectionHeader;
